import styled from 'styled-components';
import { Checkbox as CheckboxBase } from 'components/EnhancedForm';

export const Checkbox = styled(CheckboxBase)`
  & > .ui.checkbox > input.hidden {
    display: initial;
  }
`;
